import { ElementDetails } from "@/lib/types";
import { SlackFilesProps } from "./types";

export const details = {
  name: "SlackFiles",
  description: "Recent Slack files you can see",
  tags: ["Communication"],
  category: "Slack",
  grid: { default: [3, 4], large: [4, 5] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackFilesProps>;
